import { connect } from 'react-redux';
import SchedulesBoardFilter from './SchedulesBoardFilter';
import { selectSchedulesBoardTypeFilters } from '../Schedules.selectors';
import { setSchedulesBoardTypeFilters } from '../Schedules.reducers';
import { RECURRING_FILTER_OPTIONS } from './SchedulesBoard.helpers';

const mapStateToProps = state => ({
  selectedFilterKeys: selectSchedulesBoardTypeFilters(state),
  filterOptions: RECURRING_FILTER_OPTIONS,
  isTypeFilter: true,
});

const mapDispatchToProps = {
  setSchedulesBoardFilters: setSchedulesBoardTypeFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulesBoardFilter);
